// extracted by mini-css-extract-plugin
export var bgFacebook = "footer-module--bg-facebook--c9587";
export var bgLinkedin = "footer-module--bg-linkedin--91db9";
export var bgTwitter = "footer-module--bg-twitter--700b1";
export var column = "footer-module--column--31d5d";
export var columnDesc = "footer-module--column-desc--3f2c3";
export var columnHeading = "footer-module--column-heading--fc07b";
export var footerLink = "footer-module--footer-link--e349b";
export var footerLogo = "footer-module--footer-logo--2609c";
export var footerRow = "footer-module--footer-row--4e38e";
export var footerWrapper = "footer-module--footer-wrapper--584b8";
export var logoDescWrapper = "footer-module--logo-desc-wrapper--87b7a";
export var rowCopyright = "footer-module--row-copyright--6c5d6";
export var rowLegal = "footer-module--row-legal--04b43";
export var rowSocial = "footer-module--row-social--76800";
export var socialIcon = "footer-module--social-icon--a2b82";
export var socialIconWrapper = "footer-module--social-icon-wrapper--fbb5f";